import { render } from "./SoundCloud.vue?vue&type=template&id=33c89e36&scoped=true&lang=pug"
import script from "./SoundCloud.vue?vue&type=script&lang=ts"
export * from "./SoundCloud.vue?vue&type=script&lang=ts"

import "./SoundCloud.vue?vue&type=style&index=0&id=33c89e36&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-33c89e36"

export default script